module.exports = __webpack_public_path__ + "img/tras.cccd6933.png";